<template>
  <div class="horizontal-input-layout mv1">
    <label class="b-contain horizontal-input-data">
      <span>{{ field.spec.title }}</span>
      <input :disabled="!field.spec.editable" type="checkbox" v-model="proxy">
      <span style="color: red" v-for="e in field.errors" v-bind:key="e" >{{e}}</span>
      <div class="b-input"></div>
    </label>
  </div>
</template>

<script>
export default {
  props: ['field', 'template', 'saving'],
  watch: {
    field (f) {
      if (f.spec.causer) return
      this.model = f.value
    }
  },
  computed: {
    proxy: {
      get () { return this.model },
      set (v) {
        this.model = v
        this.$emit('input', { value: v, debounced: false })
      }
    }
  },
  data () {
    return {
      model: this.field.value
    }
  }
}
</script>
